import React, { useState } from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { Route, Switch, withRouter } from "react-router-dom";

import * as userActions from "./actionCreators/User";
import "antd/dist/antd.css";
import "./styles/App.css";
import { Dashboard, ForgotPassword, Login, UpdatePassword } from "./views";
import PrivacyPolicy from "./views/Dashboard/Components/PrivacyPolicy/PrivacyPolicy";
import { Spin, Button } from "antd";
import PopupModal from "./Components/PopupModal";

function App({ getCurrentUser, currentUser, loggedIn, history }) {
  const [state, setState] = React.useState({
    data: null,
    loading: null,
    error: null,
    loggedIn: false,
  });
  const [showApproveModal, setShowApproveModal] = React.useState(false);
  const [showReloginModal, setShowReloginModal] = React.useState(false);
  React.useEffect(() => {
    getCurrentUser();
  }, []);

  React.useEffect(() => {
    const { data, loading, error } = state;

    if (!loading && !data && !error) {
      setState((obj) => ({
        ...obj,
        data: currentUser.data,
        loggedIn: loggedIn,
      }));
      setShowApproveModal(currentUser?.data?.reset_password);
      if (currentUser?.data?.forceRedirectUpdatePassword) {
        history.push("/update-password");
      }
      setShowReloginModal(currentUser.forcedLogout);
    }
  }, [currentUser]);

  const navigateToLoginScreen = () => {
    setShowApproveModal(false);
    history.push("/update-password");
  };
  const navigateToReloginScreen = () => {
    setShowReloginModal(false);
    localStorage.removeItem("access-token");
    localStorage.removeItem("refresh-token");
    localStorage.removeItem("fmc-token");
    history.push("/login");
  };
  return (
    <div className="App">
      {!currentUser.error && currentUser.loading ? (
        <div className="spin-loader">
          <Spin size="large" />
        </div>
      ) : (
        <div>
          {state?.data &&
          state?.loggedIn &&
          !state?.data?.reset_password &&
          !state?.data?.forceRedirectUpdatePassword ? (
            <Dashboard />
          ) : (
            <Switch>
              <Route path="/privacy-policy">
                <PrivacyPolicy/>
              </Route>
              <Route path="/forgot-password">
                <ForgotPassword />
              </Route>
              <Route path="/login">
                <Login />
              </Route>
              <Route path="/update-password">
                <UpdatePassword />
              </Route>
              <Route path="/">
                <Login />
              </Route>
              
            </Switch>
          )}
          <PopupModal
            title={"Set New Password"}
            centered
            visible={showApproveModal}
            // onOk={() => sendForgotPasswordRequest()}
            onCancel={navigateToLoginScreen}
            footer={[
              <Button key="submit" type="link" onClick={navigateToLoginScreen}>
                SET NEW PASSWORD
              </Button>,
            ]}
          >
            <span>
              You have not changed your password in 60 days or Someone reset
              your password. Please update your password
            </span>
          </PopupModal>
          <PopupModal
            title={"You Were Logged Out"}
            centered
            visible={showReloginModal}
            onCancel={navigateToReloginScreen}
            footer={[
              <Button
                key="submit"
                type="link"
                onClick={navigateToReloginScreen}
              >
                LOGIN
              </Button>,
            ]}
          >
            <span>
              Your password or basic information has been updated, please login
              again.
            </span>
          </PopupModal>
        </div>
      )}
    </div>
  );
}

const mapStateToProps = ({ user: { currentUser, loggedIn } }) => ({
  currentUser,
  loggedIn,
});

const mapDispatchToProps = (dispatch) => ({
  getCurrentUser: bindActionCreators(userActions.getCurrentUser, dispatch),
});

App.propTypes = {
  user: PropTypes.object,
  getCurrentUser: PropTypes.func.isRequired,
};

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(App));
